import { Loader2, Video } from "lucide-react";

export default function WaitingRoom({ meetingInfo }) {

    console.log(meetingInfo);
    
    return (
        <div className="h-screen flex flex-col justify-center items-center bg-gray-100 text-center p-4">
            <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full space-y-6">
                <div className="flex justify-center">
                    <Loader2 className="animate-spin text-[#00adae] w-10 h-10" />
                </div>
                <h2 className="text-xl font-semibold text-gray-800">
                    Waiting for patient to join
                </h2>
                <p className="text-gray-600">
                    Please stay on this page. The video meeting will start automatically when the patient joins.
                </p>

                {meetingInfo && (
                    <div className="text-sm text-gray-500 mt-4">
                        <div><strong>Meeting Topic:</strong> Meeting with <span className="capitalize">{meetingInfo?.meeting.doctor_name}</span></div>
                        <div><strong>Scheduled Time:</strong> {meetingInfo?.meeting.start}</div>
                    </div>
                )}

                <div className="mt-6 flex justify-center">
                    <Video className="text-gray-400 w-8 h-8" />
                </div>
            </div>
        </div>
    );
}